export const izolacijaKoloniiLookup =
    [
        {
            id: "1", ime: "Не релевантно, немаме користено такви производи од почетокот на конверзијата"
        }
    ]